module.exports = __webpack_public_path__ + "hotpFactor@2x.665756764cd4463601789c047a9060b3.png";